define('viewModels/privileged/qm/policies/editors/EmailDomainSelectorView',[
    'lib/lodash4',
    'lib/knockout',
    'viewModels/ViewModel',
    'services/routing/emailDomainService',

    // no reference
    'extensions/i18n/knockout.i18n',
    'extensions/knockout.validation.extender',
    'lib/knockout.validation'
], function (
    _,
    ko,
    ViewModel,
    emailDomainService) {
    'use strict';

    /**
     * The EmailDomainSelectorView class.
     * @class
     */
    var EmailDomainSelectorView = ViewModel.extend(function (emailDomainObservable) {
        var self = this;

        self.loading = ko.observable(false);

        self.emailDomainObservable = emailDomainObservable;

        // use computed observable here to format the emailDomain in the same way the api response does
        // emailDomainObservable just contains the stringified name of domain
        self.emailDomain = self.computed({
            read: function () {
                return { id: self.emailDomainObservable() };
            },
            write: function (newValue) {
                self.emailDomainObservable(newValue.id);
            }
        });

        self.placeholderText = ko.i18n.renderString("emailDomainSelector.placeholderText");

        /**
         * Get paged email domains.
         *
         * @returns {Promise}
         */

        var domainIds = ko.observableArray();
        self.getEmailDomains = function () {
            var domains = [];
            return emailDomainService.get.page({ pageSize: 100 })
                .then(function (emailResponse) {
                    for(var i = 0; i < emailResponse.entities.length; i++) {
                        domains.push(emailResponse.entities[i].id);
                    }
                    domainIds(domains);
                    return emailResponse.entities || [];
                });
        };
        self.getEmailDomains();

        if (_.isArray(emailDomainObservable())) {
            self.emailDomainObservable.extend({ deepComparer: true, minLength: { params: 1, message: "emailDomainSelector.noDomainSelected" }, arrayIncludesEveryValue: {params: domainIds, message: "emailDomainSelector.aDomainValueIsNotInList" }});
        } else {
            self.emailDomainObservable.extend({ required: true, arrayIncludesValue: { params: domainIds, message: "emailDomainSelector.domainNotFound" }});
        }
    }, true /* pass args to extended class */);

    return EmailDomainSelectorView;
});

